import * as React from 'react';
import clsx from 'clsx';

import { Grid, withStyles, WithStyles } from '@nelnet/unifi-components-react';

import getActiveElement from '../../utils/getActiveElement';

import styles from './styles/pagestyles';

interface IPageContentProps extends WithStyles<typeof styles> {
  path: string;
}

const PageContent: React.FunctionComponent<IPageContentProps> = ({ classes, children, path }) => {
  const sectionFocusEl = React.createRef<HTMLDivElement>();
  const changeTrigger = getActiveElement();

  React.useEffect(() => {
    if (changeTrigger && changeTrigger.tagName.toLowerCase() !== 'body') {
      const node = sectionFocusEl.current!;
      if (node.querySelector('h1')) {
        node.querySelector('h1')!.focus();
      }
    }
  }, []);

  const rootHome = path === '' ? classes.rootHome : '';
  const rootWide = path === '/theming/demo/' ? classes.rootWide : '';
  const formDemo = path.includes('forms') ? classes.formDemo : '';

  return (
    <main
      id="main"
      className={clsx(classes.root, rootHome, rootWide)}
      tabIndex={-1}
      ref={sectionFocusEl}
    >
      <Grid container padding={{ right: 3, bottom: 3 }}>
        <Grid item xs={12} className={clsx(classes.page, formDemo)}>
          {children}
        </Grid>
      </Grid>
    </main>
  );
};

export default withStyles(styles)(PageContent);
